import { BroadcastedValue, BroadcastState } from '~/types';
import { CreateLocationEvent } from './types';
import { useBroadcastedValue } from '~/useBroadcastedValue';
import { useBroadcastState } from '~/useBroadcastState';

export const useCreateLocationBroadcastedValue: BroadcastedValue<CreateLocationEvent> = ({
  initialValue,
} = {}) => {
  return useBroadcastedValue({
    channel: 'locations',
    event: 'create-location',
    initialValue,
  });
};

export const useCreateLocationBroadcastState: BroadcastState<CreateLocationEvent> = ({
  initialValue,
} = {}) => {
  return useBroadcastState({
    channel: 'locations',
    event: 'create-location',
    initialValue,
  });
};
